import { useRouter } from "next/router";

const HOMEPAGE_PATHNAME = "/[language]/[[...slug]]";
const SLUG_QUERY_PARAM = "slug";

const useExtendedRouter = () => {
  const router = useRouter();
  const { pathname, query, asPath } = router;

  const isHomepage = pathname === HOMEPAGE_PATHNAME && !Object.prototype.hasOwnProperty.call(query, SLUG_QUERY_PARAM);
  const pathWithoutHash = (asPath.includes("#")) ? asPath.split("#")[0] : asPath;

  return { ...router, isHomepage, pathWithoutHash };
};

export default useExtendedRouter;
